import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import {  Inject, NgZone, PLATFORM_ID } from '@angular/core';
import Swal from 'sweetalert2';

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';

import * as am5map from "@amcharts/amcharts5/map";
import * as am5percent from "@amcharts/amcharts5/percent";
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";

import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";

@Component({
  selector: 'app-da-student-feedback',
  templateUrl: './da-student-feedback.component.html',
  styleUrls: ['./da-student-feedback.component.scss']
})
export class DaStudentFeedbackComponent implements OnInit {

 MeetingOptions:any;
  participantsptions: any;
   userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
   users: any = JSON.parse(localStorage.getItem('login_user_details'));
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  isButtonDisabled :boolean=false;
  CM_id: any;
  editmeetingform !:FormGroup;
  da_district:string;
  district: any = this.ApiService.user_details.district;
  constituency: any = this.ApiService.constituency;
  courses: any;
  userDistrict: any = this.ApiService.user_details.district;
  userConstituency: any = this.ApiService.user_details.constituency;
  userId: any = this.ApiService.user_details.id;
  ob_data: any;
  mentor_data: any;
  enableButton: boolean;
  CM_course_image: any;



  onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }


  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe, @Inject(PLATFORM_ID) private platformId: Object,private zone: NgZone) {
    this.createmeetingform= this.fb.group({
      course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date: [this.getCurrentDates(), Validators.required],
      course_end_date: [this.getCurrentDates(), Validators.required],
      course_start_time: [this.getCurrentTime(), Validators.required],
      course_end_time: [this.getCurrentTime(), Validators.required],
        volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
      status:[''],
      image:['']
    });
    this.editformInitialize('false');
    this.district = JSON.parse(localStorage.getItem('user_district'));

  }

   // Run the function only in the browser
  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }


 


    ngAfterViewInit() {
    // Chart code goes in here
    this.browserOnly(() => {

  


    })
  
}


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit():void{
   
    this.date = new Date();

      this.ApiService.courseAssignedToMentor(this.users.first_name).subscribe((data: any) => {
       console.log(data, "sknsdnjs");
        this.mentor_data = data;  
         
// https://www.amcharts.com/docs/v5/getting-started/#Root_element

      })
    
    
    
      this.ApiService.getStudentFeedbackList(this.userForm.district).subscribe((data: any) => {
        console.log(data, "checking");
        this.enableButton = false; // Initially disable the button
        let currentDate = new Date(); // Get the current date
        
        // Check if any customer has a start date in the past
        if (data.some((customer: any) => {
          let startDate = new Date(customer.start_date + 'T' + customer.start_time); // Combine start_date and start_time strings into a single Date object
          return currentDate.getTime() >= startDate.getTime(); // Return true if the start date is in the past
        })) {
          this.enableButton = true; // Enable the button if any customer has a start date in the past
        }
        
        this.customers = data;
        this.tableshow = true;
      });
      
  

    this.ApiService.getOBDetailsForDistrictOccurance().subscribe((data) => {
      this.ob_data = data;
    })
    
// document.write(today);
    this.customers=[];
    this.showSpinner();
    // this.ApiService.getDistrictOccurance().subscribe((data:any) => {
      
    //   this.customers=data;
    //   this.tableshow=true;
    //   //console.log(this.customers.length);
    //   //console.log(obj.data.length);
    //   console.log(this.customers);
      
    // })
    
     this.ApiService.getCourses().subscribe((data: any) => {
       console.log(data, "s,mfdnsd");
       this.courses = data;
     
      
      
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [2,'asc']
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  this.da_district=localStorage.getItem('user_district');
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('district').setValue(this.userDistrict);
    this.createmeetingform.get('constituency').setValue(this.userConstituency);
    this.createmeetingform.get('user_id').setValue(this.userId);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  customers:any=[];
  


  postdata(angForm1: any) {
    console.log(angForm1.value);
  
    this.ApiService.createDistrictOccurance(angForm1.value).subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
        Swal.fire({
          title: 'Success!',
          text: 'Course District Occurrence has been created successfully!',
          icon: 'success',
          confirmButtonText: 'Okay',
          iconColor:'#015792',
          confirmButtonColor: '#015792',
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      },
      error => {
        console.log(error);
      }
    );
  }
  
    
 

  delete_CM(id: any) {
    console.log(id);
    Swal.fire({
      title: 'Confirm Deletion',
      text: 'Are you sure you want to cancel this District Occurrence?',
      icon: 'warning',
      showCancelButton: true,
      iconColor:'#015792',
    confirmButtonColor: '#015792',
    cancelButtonColor: '#e5183b',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.ApiService.deleteDistrictOccurance(id)
          .subscribe(
            data => {
              window.location.reload();
              Swal.fire(
                'Deleted!',
                'Course District Occurrence has been deleted successfully.',
                'success'
              );
            },
            error => {
              console.log(error);
            }
          );
      }
    });
  }
  

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
  }
  CM_course_name: any;
  CM_district: any;
  CM_constituency: any;
  CM_organizer: any;
  CM_startDate: any;
  CM_endDate: any;
  CM_startTime: any;
  CM_endTime: any;
  CM_volunteer1: any;
  CM_volunteer2: any;
  CM_location: any;
  CM_status: any;
  CM_comments: any;

  CM_course_id: any;

  editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a, editbutton);
    
//     this.ApiService.getStudentGraphStudent(a.course_id).subscribe((d:any) => {
//       console.log(d, "dsndsnsj");

//       /* Chart code */

// // Create root element
// // https://www.amcharts.com/docs/v5/getting-started/#Root_element
// let root = am5.Root.new("graphDiv");


// let myTheme = am5.Theme.new(root);

// myTheme.rule("Grid", ["base"]).setAll({
//   strokeOpacity: 0.1
// });


// // Set themes
// // https://www.amcharts.com/docs/v5/concepts/themes/
// root.setThemes([
//   am5themes_Animated.new(root),
//   myTheme
// ]);


// // Create chart
// // https://www.amcharts.com/docs/v5/charts/xy-chart/
// let chart = root.container.children.push(
//   am5xy.XYChart.new(root, {
//     panX: false,
//     panY: false,
//     wheelX: "none",
//     wheelY: "none",
//     paddingLeft: 0
//   })
// );


// // Create axes
// // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
// let yRenderer = am5xy.AxisRendererY.new(root, {
//   minGridDistance: 30
// });
// yRenderer.grid.template.set("location", 1);

// let yAxis = chart.yAxes.push(
//   am5xy.CategoryAxis.new(root, {
//     maxDeviation: 0,
//     categoryField: "name",
//     renderer: yRenderer
//   })
// );

// let xAxis = chart.xAxes.push(
//   am5xy.ValueAxis.new(root, {
//     maxDeviation: 0,
//     min: 0,
//     renderer: am5xy.AxisRendererX.new(root, {
//       visible: true,
//       strokeOpacity: 0.1,
//       minGridDistance: 80
//     })
//   })
// );


// // Create series
// // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
// let series = chart.series.push(
//   am5xy.ColumnSeries.new(root, {
//     name: "Series 1",
//     xAxis: xAxis,
//     yAxis: yAxis,
//     valueXField: "value",
//     sequencedInterpolation: true,
//     categoryYField: "name"
//   })
// );

// let columnTemplate = series.columns.template;

// columnTemplate.setAll({
//   draggable: true,
//   cursorOverStyle: "pointer",
//   tooltipText: "drag to rearrange",
//   cornerRadiusBR: 10,
//   cornerRadiusTR: 10,
//   strokeOpacity: 0
// });
// columnTemplate.adapters.add("fill", (fill, target) => {
//   return chart.get("colors").getIndex(series.columns.indexOf(target));
// });

// columnTemplate.adapters.add("stroke", (stroke, target) => {
//   return chart.get("colors").getIndex(series.columns.indexOf(target));
// });

// columnTemplate.events.on("dragstop", () => {
//   sortCategoryAxis();
// });

// // Get series item by category
//       function getSeriesItem(category: any) {
//         let dataItem: any;
//   for (var i = 0; i < series.dataItems.length; i++) {
//      dataItem = series.dataItems[i];
//     if (dataItem.get("categoryY") == category) {
//       return dataItem;
//     }
//   }
  
// }


// // Axis sorting
// function sortCategoryAxis() {
//   // Sort by value
//   series.dataItems.sort(function (x, y) {
//     return y.get("graphics").y() - x.get("graphics").y();
//   });

//   let easing = am5.ease.out(am5.ease.cubic);

//   // Go through each axis item
//   am5.array.each(yAxis.dataItems, function (dataItem) {
//     // get corresponding series item
//     let seriesDataItem = getSeriesItem(dataItem.get("category"));

//     if (seriesDataItem) {
//       // get index of series data item
//       let index = series.dataItems.indexOf(seriesDataItem);

//       let column = seriesDataItem.get("graphics");

//       // position after sorting
//       let fy =
//         yRenderer.positionToCoordinate(yAxis.indexToPosition(index)) -
//         column.height() / 2;

//       // set index to be the same as series data item index
//       if (index != dataItem.get("index")) {
//         dataItem.set("index", index);

//         // current position
//         let x = column.x();
//         let y = column.y();

//         column.set("dy", -(fy - y));
//         column.set("dx", x);

//         column.animate({ key: "dy", to: 0, duration: 600, easing: easing });
//         column.animate({ key: "dx", to: 0, duration: 600, easing: easing });
//       } else {
//         column.animate({ key: "y", to: fy, duration: 600, easing: easing });
//         column.animate({ key: "x", to: 0, duration: 600, easing: easing });
//       }
//     }
//   });

//   // Sort axis items by index.
//   // This changes the order instantly, but as dx and dy is set and animated,
//   // they keep in the same places and then animate to true positions.
//   yAxis.dataItems.sort(function (x, y) {
//     return x.get("index") - y.get("index");
//   });
// }




// yAxis.data.setAll(d);
// series.data.setAll(d);


// // Make stuff animate on load
// // https://www.amcharts.com/docs/v5/concepts/animations/
// series.appear(1000);
// chart.appear(1000, 100);



   
//      })

// this.ApiService.getStudentGraphStudent(a.course_id).subscribe((d: any) => {
//   /* Chart code */

//   // Create root element
//   let root = am5.Root.new("graphDiv");

//   // Set themes
//   let myTheme = am5.Theme.new(root);
//   myTheme.rule("Grid", ["base"]).setAll({
//     strokeOpacity: 0.1
//   });
//   root.setThemes([
//     am5themes_Animated.new(root),
//     myTheme
//   ]);

//   // Create chart
//   let chart = root.container.children.push(
//     am5xy.XYChart.new(root, {
//       panX: false,
//       panY: false,
//       wheelX: "none",
//       wheelY: "none",
//       paddingLeft: 0
//     })
//   );

//   // Create axes
//   let yRenderer = am5xy.AxisRendererY.new(root, {
//     minGridDistance: 30
//   });
//   yRenderer.grid.template.set("location", 1);

//   let yAxis = chart.yAxes.push(
//     am5xy.CategoryAxis.new(root, {
//       maxDeviation: 0,
//       categoryField: "name",
//       renderer: yRenderer
//     })
//   );

//   let xAxis = chart.xAxes.push(
//     am5xy.ValueAxis.new(root, {
//       maxDeviation: 0,
//       min: 0,
//       renderer: am5xy.AxisRendererX.new(root, {
//         visible: true,
//         strokeOpacity: 0.1,
//         minGridDistance: 80
//       })
//     })
//   );

//   // Create series
//   let series1 = chart.series.push(
//     am5xy.ColumnSeries.new(root, {
//       name: "Series 1",
//       xAxis: xAxis,
//       yAxis: yAxis,
//       valueXField: "value1",
//       sequencedInterpolation: true,
//       categoryYField: "category"
//     })
//   );

//   let series2 = chart.series.push(
//     am5xy.ColumnSeries.new(root, {
//       name: "Series 2",
//       xAxis: xAxis,
//       yAxis: yAxis,
//       valueXField: "value2",
//       sequencedInterpolation: true,
//       categoryYField: "category"
//     })
//   );

//   let series3 = chart.series.push(
//     am5xy.ColumnSeries.new(root, {
//       name: "Series 3",
//       xAxis: xAxis,
//       yAxis: yAxis,
//       valueXField: "value3",
//       sequencedInterpolation: true,
//       categoryYField: "category"
//     })
//   );

//   let columnTemplate = series1.columns.template;

//   columnTemplate.setAll({
//     draggable: true,
//     cursorOverStyle: "pointer",
//     tooltipText: "drag to rearrange",
//     cornerRadiusBR: 10,
//     cornerRadiusTR: 10,
//     strokeOpacity: 0
//   });
//   columnTemplate.adapters.add("fill", (fill, target) => {
//     return chart.get("colors").getIndex(series1.columns.indexOf(target));
//   });

//   columnTemplate.adapters.add("stroke", (stroke, target) => {
//     return chart.get("colors").getIndex(series1.columns.indexOf(target));
//   });

//   columnTemplate.events.on("dragstop", () => {
//     sortCategoryAxis();
//   });

//   // Get series item by category
//   function getSeriesItem(category: any) {
//     let dataItem: any;
//     for (var i = 0; i < series1.dataItems.length; i++) {
//       dataItem = series1.dataItems[i];
//       if (dataItem.get("categoryY") == category) {
//         return dataItem;
//       }
//     }
//   }

//   // Axis sorting
//   function sortCategoryAxis() {
//     // Sort by value
//     series1.dataItems.sort(function (x, y) {
//       return y.get("graphics").y() - x.get("graphics").y();
//     });

//     let easing = am5.ease.out(am5.ease.cubic);

//     // Go through each axis item
//     am5.array.each(yAxis.dataItems, function (dataItem) {
//       // get corresponding series item
//       let seriesDataItem = getSeriesItem(dataItem.get("category"));

//       if (seriesDataItem) {
//         // get index of series data item
//         let index = series1.dataItems.indexOf(seriesDataItem);

//         let column = seriesDataItem.get("graphics");

//         // position after sorting
//         let fy =
//           yRenderer.positionToCoordinate(yAxis.indexToPosition(index)) -
//           column.height() / 2;

//         // set index to be the same as series data item index
//         if (index != dataItem.get("index")) {
//           dataItem.set("index", index);

//           // current position
//           let x = column.x();
//           let y = column.y();

//           column.set("dy", -(fy - y));
//           column.set("dx", x);

//           column.animate({ key: "dy", to: 0, duration: 600, easing: easing });
//           column.animate({ key: "dx", to: 0, duration: 600, easing: easing });
//         } else {
//           column.animate({ key: "y", to: fy, duration: 600, easing: easing });
//           column.animate({ key: "x", to: 0, duration: 600, easing: easing });
//         }
//       }
//     });

//     // Sort axis items by index.
//     // This changes the order instantly, but as dx and dy is set and animated,
//     // they keep in the same places and then animate to true positions.
//     yAxis.dataItems.sort(function (x, y) {
//       return x.get("index") - y.get("index");
//     });
//   }

//  // Set data for each series
//  series1.data.setAll(d);
//  series2.data.setAll(d);
//  series3.data.setAll(d);

//  // Make stuff animate on load
//  series1.appear(1000);
//  series2.appear(1000);
//  series3.appear(1000);
//  chart.appear(1000, 100);
// });

this.ApiService.getStudentGraphStudent(a.course_id).subscribe((d: any) => {
// Create root and chart
var root = am5.Root.new("chartdiv"); 

root.setThemes([
  am5themes_Animated.new(root)
]);

var chart = root.container.children.push( 
  am5xy.XYChart.new(root, {
    panY: false,
    // wheelY: "zoomX",
    layout: root.verticalLayout
  }) 
);

// Define data based on backend structure (assuming data is already fetched and available in a variable called 'feedbackData')
var data = d;

// Craete Y-axis
let yAxis = chart.yAxes.push(
  am5xy.ValueAxis.new(root, {
    renderer: am5xy.AxisRendererY.new(root, {
    })
  })
);

// Create X-Axis
var xAxis = chart.xAxes.push(
  am5xy.CategoryAxis.new(root, {
    maxDeviation: 0.2,
    renderer: am5xy.AxisRendererX.new(root, {
    }),
    categoryField: "category"
  })
);

// Update xAxis data after processing backend data
xAxis.data.setAll(data);

// Create series based on backend data structure
var series1 = chart.series.push( 
  am5xy.ColumnSeries.new(root, { 
    name: "✯",  // Add meaningful names for series
    xAxis: xAxis, 
    yAxis: yAxis, 
    valueYField: "value1", 
    categoryXField: "category",
    tooltip: am5.Tooltip.new(root, {})
  }) 
);
series1.data.setAll(data);

var series2 = chart.series.push( 
  am5xy.ColumnSeries.new(root, { 
    name: "✯✯",  // Add meaningful names for series
    xAxis: xAxis, 
    yAxis: yAxis, 
    valueYField: "value2", 
    categoryXField: "category" 
  }) 
);
series2.data.setAll(data);

var series3 = chart.series.push( 
  am5xy.ColumnSeries.new(root, { 
    name: "✯✯✯",  // Add meaningful names for series
    xAxis: xAxis, 
    yAxis: yAxis, 
    valueYField: "value3", 
    categoryXField: "category" 
  }) 
);
series3.data.setAll(data);

var series4 = chart.series.push( 
  am5xy.ColumnSeries.new(root, { 
    name: "✯✯✯✯",  // Add meaningful names for series
    xAxis: xAxis, 
    yAxis: yAxis, 
    valueYField: "value4", 
    categoryXField: "category" 
  }) 
);
series4.data.setAll(data);

var series5 = chart.series.push( 
  am5xy.ColumnSeries.new(root, { 
    name: "✯✯✯✯✯",  // Add meaningful names for series
    xAxis: xAxis, 
    yAxis: yAxis, 
    valueYField: "value5", 
    categoryXField: "category" 
  }) 
);
series5.data.setAll(data);
// Add more series definitions for additional feedback categories if needed (following the same pattern)

// Add legend
var legend = chart.children.push(am5.Legend.new(root, {
  layout: root.horizontalLayout,
  centerX: am5.percent(50),
  x: am5.percent(50),
})); 
legend.data.setAll(chart.series.values);

});

// // Create root and chart
// var root = am5.Root.new("chartdiv"); 

// root.setThemes([
//   am5themes_Animated.new(root)
// ]);

// var chart = root.container.children.push( 
//   am5xy.XYChart.new(root, {
//     panY: false,
//     wheelY: "zoomX",
//     layout: root.verticalLayout
//   }) 
// );

// // Define data
// var data = [{ 
//   category: "Research", 
//   value1: 1000, 
//   value2: 588,
//   value3:200,
//   value4:500,
//   value5:1500
// }, { 
//   category: "Marketing", 
//   value1: 1200, 
//   value2: 1800,
//   value3:200,
//   value4:500,
//   value5:1500
// }, { 
//   category: "Sales", 
//   value1: 850, 
//   value2: 1230,
//   value3:200,
//   value4:500,
//   value5:1500
// },
// { 
//   category: "Research", 
//   value1: 1000, 
//   value2: 588,
//   value3:200,
//   value4:500,
//   value5:1500
// },
// { 
//   category: "Research1", 
//   value1: 1000, 
//   value2: 588,
//   value3:200,
//   value4:500,
//   value5:1500
// }];

// // Craete Y-axis
// let yAxis = chart.yAxes.push(
//   am5xy.ValueAxis.new(root, {
//     renderer: am5xy.AxisRendererY.new(root, {
//     })
//   })
// );

// // Create X-Axis
// var xAxis = chart.xAxes.push(
//   am5xy.CategoryAxis.new(root, {
//       maxDeviation: 0.2,
//       renderer: am5xy.AxisRendererX.new(root, {
//     }),
//     categoryField: "category"
//   })
// );
// xAxis.data.setAll(data);

// // Create series
// var series1 = chart.series.push( 
//   am5xy.ColumnSeries.new(root, { 
//     // name: "Series", 
//     xAxis: xAxis, 
//     yAxis: yAxis, 
//     valueYField: "value1", 
//     categoryXField: "category",
//     tooltip: am5.Tooltip.new(root, {})
//   }) 
// );
// series1.data.setAll(data);

// var series2 = chart.series.push( 
//   am5xy.ColumnSeries.new(root, { 
//     // name: "Series", 
//     xAxis: xAxis, 
//     yAxis: yAxis, 
//     valueYField: "value2", 
//     categoryXField: "category" 
//   }) 
// );
// series2.data.setAll(data);
// var series3 = chart.series.push( 
//   am5xy.ColumnSeries.new(root, { 
//     // name: "Series", 
//     xAxis: xAxis, 
//     yAxis: yAxis, 
//     valueYField: "value2", 
//     categoryXField: "category" 
//   }) 
// );
// series3.data.setAll(data);
// var series4 = chart.series.push( 
//   am5xy.ColumnSeries.new(root, { 
//     // name: "Series", 
//     xAxis: xAxis, 
//     yAxis: yAxis, 
//     valueYField: "value2", 
//     categoryXField: "category" 
//   }) 
// );
// series4.data.setAll(data);
// var series5 = chart.series.push( 
//   am5xy.ColumnSeries.new(root, { 
//     // name: "Series", 
//     xAxis: xAxis, 
//     yAxis: yAxis, 
//     valueYField: "value2", 
//     categoryXField: "category" 
//   }) 
// );
// series5.data.setAll(data);

// // Add legend
// var legend = chart.children.push(am5.Legend.new(root, {})); 
// legend.data.setAll(chart.series.values);

    //console.log(a.date)
    if (editbutton == 'edit') {
      this.editfield = true;
    } else {
      this.editfield = false;
    }
      this.CM_course_name=a.course_name;
          this.CM_district=a.district;
          this.CM_constituency=a.constituency;
    this.CM_startDate = this.datepipe.transform(a.start_date, 'dd-MM-yyyy'); 
    this.CM_organizer = a.organizer;
          this.CM_endDate=  this.datepipe.transform(a.end_date, 'dd-MM-yyyy');
          this.CM_startTime=a.start_time;
          this.CM_endTime=a.end_time;
          this.CM_volunteer1=a.volunteer1;
    this.CM_volunteer2 = a.volunteer2;
    this.CM_location = a.location;
    this.CM_status = a.status;
    this.CM_comments = a.comments;
    this.CM_id = a.id;
    this.CM_course_id = a.course_id;
    this.CM_course_image=a.image;

  
    this.editmeetingform.get('course_name').setValue(a.course_name);
    this.editmeetingform.get('comments').setValue(a.comments);
    this.editmeetingform.get('topic_clarity').setValue(a.topic_clarity);
    this.editmeetingform.get('overall_co_ordination').setValue(a.overall_co_ordination);
    this.editmeetingform.get('overall_understanding').setValue(a.overall_understanding);
    this.editmeetingform.get('facilities_in_venue').setValue(a.facilities_in_venue);
    this.editmeetingform.get('overall_rating_about_session').setValue(a.overall_rating_about_session);
    this.editmeetingform.get('organizer').setValue(a.organizer);
      
          //this.editformInitialize(false);
      
   
    // this.editmeetingform.get('meeting_date').setValue(a.date);
    // this.editmeetingform.get('meeting_time').setValue(a.time);
          //this.editmeetingform.controls['meeting_date'].disable();
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_date);
        //  this.editmeetingform.controls['meeting_date'].setValue(this.CM_time);

    }

          editformInitialize(a){
            this.editmeetingform= this.fb.group({
           course_name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      district:[this.current_date,Validators.required ],
      constituency:[this.current_time,Validators.required],
      organizer:['',Validators.required],
      course_start_date:['',Validators.required],
      course_end_date: ['', Validators.required],
      course_start_time:['',Validators.required],
      course_end_time: ['', Validators.required],
      volunteer1:['',Validators.required],
      volunteer2: ['', Validators.required],
      user_id:[''],
      comments:[''],
      course_location:['',Validators.required],
              status: [''],
              topic_clarity: [''],
              facilities_in_venue: [''],
              overall_rating_about_session: [''],
              overall_understanding: [''],
              overall_co_ordination:[''],
              image:['']
          });
          }
        
          updatedata(updateform,id){
            console.log(updateform,id);  
            this.spinner = true;
            let values = updateform.value;
            values['course_id'] = this.CM_course_id;
            values['student_id'] = this.CM_id;
            this.ApiService.updateStudentFeedback(updateform.value).pipe().subscribe(
              data => {
                console.log(data);
                this.spinnerService.hide();
                setTimeout(function () {
                  Swal.fire({
title: "Student Feedback updated Successfully!",
icon: "success",
 confirmButtonText: "Okay",
 iconColor:'#015792',
 confirmButtonColor: '#015792',
}).then((result) => {
/* Read more about isConfirmed, isDenied below */
if (result.isConfirmed) {
window.location.reload();
} 
});
   }, 100)
                  
                },
              
              error => {
                console.log(error);
              });
          }

//reset form values in createform
  Formreset(){
    this.createmeetingform.reset();
    this.hidden=true;
    this.MeetingOptions='';
    //this.participantsptions='';
}
isStartDateInTheFuture(item: any): boolean {
  let startDate = new Date(item.start_date + 'T' + item.start_time); // Combine start_date and start_time strings into a single Date object
  let currentDate = new Date(); // Get the current date
  return currentDate.getTime() < startDate.getTime(); // Return true if the start date is in the future
}
getCurrentDates(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Function to get the current time in the format HH:MM
getCurrentTime(): string {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

}
